import { render, staticRenderFns } from "./L2Domains.vue?vue&type=template&id=c96430da&"
import script from "./L2Domains.vue?vue&type=script&lang=js&"
export * from "./L2Domains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports